var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.57 5.92969C21.4447 7.80496 22.4979 10.348 22.4979 12.9997C22.4979 15.6513 21.4447 18.1944 19.57 20.0697M16.04 9.45969C16.9774 10.3973 17.504 11.6689 17.504 12.9947C17.504 14.3205 16.9774 15.592 16.04 16.5297",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3C7.61487 3 10.14 5.80902 10.14 9.27405V10.0932L11.5 12.5C12.5 14 11.3239 13.6177 10.6309 13.6177H10.14C10.5481 14.763 10.2896 15.1062 10.2896 16.2453L9.98698 16.9245L10.14 17.9613C10.14 18.6599 9.80602 19.2714 9.30812 19.6097C8.99801 19.8204 8.66466 19.8483 8.37084 19.8053C8.0824 19.763 7.80612 19.6489 7.57886 19.5406L5.80156 18.6932L4.84272 21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.50f53d9b7248b2b1ea69605bdae1c5bf.svg";
export { ForwardRef as ReactComponent };